import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class LPService {

	constructor(private http: HttpClient) {
	}

	getPartnerProducts(merchantId: string): Observable<Object> {
		const url = `${environment.apiUrl}partnerproducts/${environment.institutionCode}/${merchantId}`;
		return this.http.get(url, {headers: new HttpHeaders({'X-Skip-Interceptor': 'skip'})});
	}

	getRatesDetails(loanPurpose: string | null, cardName: string | null, product: string | null): Observable<Object> {
		const url = `${environment.apiUrl}lp/rates/${environment.institutionCode}/${environment.institutionCode}/${loanPurpose}/${product}?subProduct=${cardName}`
		return this.http.get(url, {headers: new HttpHeaders({'X-Skip-Interceptor': 'skip'})});
	}

	getRatesLookup(): Observable<Object> {
		const url = `${environment.apiUrl}lp/rates/lookup/offerdetails/${environment.institutionCode}`
		return this.http.get(url, {headers: new HttpHeaders({'X-Skip-Interceptor': 'skip'})});
	}

	getLender(loanPurpose: string | null,): Observable<Object> {
		const url = `${environment.apiUrl}lp/lender/${environment.institutionCode}/${environment.institutionCode}/${loanPurpose}`
		return this.http.get(url, {headers: new HttpHeaders({'X-Skip-Interceptor': 'skip'})});
	}

	getTermsConditions(fileName: string): Observable<any> {
		const headers = new HttpHeaders({
			'X-Skip-Auth': 'Yes',
			'Accept': 'text/plain, */*',
			'X-Skip-Interceptor': 'skip',
			'X-Skip-Headers': 'Skip'
		});
		return this.http.get<any>(`${environment.s3Url}html/${environment.institutionCode}/${fileName.toLowerCase()}`,
			{headers, responseType: 'text' as 'json'})
	}

	getApplyByMailLink(merchantId: string | null, subProductName: string | null): Observable<Object> {
		const url = `${environment.apiUrl}lp/documents/mail-application/${environment.institutionCode}/${merchantId}/${subProductName}`;
		return this.http.get(url, {headers: new HttpHeaders({'X-Skip-Interceptor': 'skip'})});
	}
}
